import { render, staticRenderFns } from "./policy-tables-configure-preview.vue?vue&type=template&id=4641bfb9&scoped=true"
import script from "./policy-tables-configure-preview.vue?vue&type=script&lang=js"
export * from "./policy-tables-configure-preview.vue?vue&type=script&lang=js"
import style0 from "./policy-tables-configure-preview.vue?vue&type=style&index=0&id=4641bfb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4641bfb9",
  null
  
)

export default component.exports